import { graphqlClient, TGraphQLSubscriptions } from '../graphql-api-client/graphql-api-client';
import * as subscriptions from '../../graphql/subscriptions';
import { LiveStreamStatus } from '../../constans/presenter-enums';

export interface IKnovioCommand {
  backup_stream: boolean;
  backup_stream_time: number;
  content: string;
  stream_time: number;
  type: LiveStreamStatus;
}

export interface IOnKnovioPublish {
  livePresentationId: number;
  idHash: string;
  presentationLink: string;
  liveCommand: IKnovioCommand;
}

export interface IOnKnovioCommand {
  onKnovioCommand: IKnovioCommand;
}

export interface IOnKnovioPublishCommand {
  onKnovioPublishCommand: IOnKnovioPublish;
}

type TSubscription<T> = (
  livePresentationId: number | null,
  doneCallback: (data: T) => void,
  retrySubscriptionFn: () => TGraphQLSubscriptions
) => TGraphQLSubscriptions;

export const onKnovioPublishCommandSubscription: TSubscription<IOnKnovioPublishCommand> = (
  livePresentationId,
  doneCallback,
  retrySubscriptionFn
): TGraphQLSubscriptions => {
  return graphqlClient.subscriptions({
    query: subscriptions.onKnovioPublishCommand,
    variables: {
      livePresentationId: livePresentationId
    }
  }, doneCallback, retrySubscriptionFn);
};

export const onKnovioCommandSubscription: TSubscription<IOnKnovioCommand> = (
  livePresentationId,
  doneCallback,
  retrySubscriptionFn
): TGraphQLSubscriptions => {
  return graphqlClient.subscriptions({
    query: subscriptions.onKnovioCommand,
    variables: {
      livePresentationId: livePresentationId
    }
  }, doneCallback, retrySubscriptionFn);
};